import styles from './template.css';
import template from './template';
import {AoflElement, customElement, property} from '@aofl/element';
import {storeInstance} from '@aofl/store/dist/legacy';
import {routerInstance} from '@aofl/router';
import {environment, sdoNs} from '../constants-enumerate';
import {SearchParams} from '../search-url-params';
import {mapStatePropertiesMixin} from '@aofl/map-state-properties-mixin';
import {defaults} from '@aofl/object-utils';
import {i18nMixin} from '@aofl/i18n-mixin';
import translations from '../i18n';
import debounce from 'debounce';

/**
 * @summary SearchForm
 * @extends {i18nMixin(mapStatePropertiesMixin(AoflElement))}
 */
@customElement('search-form')
class SearchForm extends i18nMixin(mapStatePropertiesMixin(AoflElement)) {
  /**
   * Creates an instance of SearchForm.
   */
  constructor() {
    super();
    this.storeInstance = storeInstance;
    this.translations = translations;
    this.queryDebounce = debounce((e) => {
      this.storeInstance.commit(
        {namespace: this['search-namespace'], mutationId: 'removeSortLastValues'}
      );
      this.dispatchEvent(new CustomEvent('query-changed'));
    }, 200);
  }

  /**
   * @readonly
   */
  static is = 'search-form';
  @property({type: String})
  placeholder = '';

  @property({type: String, attribute: false})
  searchString = '';

  @property({type: String})
  ['search-namespace'] = sdoNs.GROUP_SEARCH;

  @property({type: Array, attribute: false})
  searchFilters = [];

  autofocus = false;
  searchTargetUrl = '';
  defaultQueryObj = {};

  inputHandler(e) {
    this.searchString = e.target.value;
    this.storeInstance.commit({namespace: this['search-namespace'], mutationId: 'setQuerySearchQuery', payload: this.searchString});
    this.queryDebounce();
  }

  filterChangedHandler(e) {
    const field = e.target.value;
    this.storeInstance.commit(
      {namespace: this['search-namespace'], mutationId: 'setQuerySearchField', payload: field},
      {namespace: this['search-namespace'], mutationId: 'removeSortLastValues'}
    );
  }

  submit(e) {
    e.preventDefault();
    const formData = new FormData(e.target);
    const payload = (formData.get('q') || '').trim();

    this.storeInstance.commit(
      {namespace: this['search-namespace'], mutationId: 'setQuerySearchQuery', payload},
      {namespace: this['search-namespace'], mutationId: 'removeSortLastValues'}
    );
    this.search();
  }

  async search() {
    const state = storeInstance.getState();
    const search = state[this['search-namespace']].queryObj.search;
    const sort = state[this['search-namespace']].queryObj.sort;
    const newQueryObj = {search};
    defaults(newQueryObj, this.defaultQueryObj);
    newQueryObj.sort.fields = sort.fields;
    const searchParams = SearchParams.encode(newQueryObj);
    try {
      await routerInstance.navigate(`${this.searchTargetUrl}?${searchParams}`, {});
    } catch (e) {}
  }

  firstUpdated() {
    super.firstUpdated();
    if (this.getAttribute('autofocus') !== null) {
      const searchElement = this.shadowRoot.querySelector('[name=q]');
      searchElement.focus();
    }
  }
  mapStateProperties() {
    const state = this.storeInstance.getState();

    this.searchString = state[this['search-namespace']].queryObj.search.query;
    this.defaultQueryObj = state[this['search-namespace']].defaultQueryObj;
    this.searchTargetUrl = state[this['search-namespace']].searchTargetUrl;
  }
  /**
   *
   * @return {Object}
   */
  render() {
    return super.render({
      default: {template, styles: [styles]}
    });
  }
}

export default SearchForm;
